export const OFFLINE_PATTERN_TYPES = [13, 14, 15]; // 线下支付模式，匹配字段为patternType
